import { useEffect } from 'react'
import { useRouter } from 'expo-router'
import { Platform } from 'react-native'
import { useTranslation } from 'react-i18next'
import { isIsolatedPreviewBuild } from '../../lib/runtime-build'
import { GateFallback } from '../../components/ui/GateFallback'
import { isWebCredentialPath } from '../../lib/navigation/web-auth-route'

export default function AuthIndexRedirect() {
  const router = useRouter()
  const { t } = useTranslation()
  // Expo Router can mount the group's initial `index` for one frame while a
  // direct web deep link such as `/register` is resolving. Preserve the
  // public credential URL instead of letting Preview's discovery default
  // swallow it; only a true root visit selects the Preview landing.
  const requestedCredentialPath =
    Platform.OS === 'web' &&
    typeof window !== 'undefined' &&
    isWebCredentialPath(window.location.pathname)
      ? window.location.pathname
      : null
  const destination =
    requestedCredentialPath ?? (isIsolatedPreviewBuild ? '/(tabs)/explore' : '/(auth)/welcome')

  // Expo Router's declarative Redirect dispatches while this route is still
  // being mounted in the development client, which triggers React's
  // "state update on a component that hasn't mounted" warning. Dispatch only
  // after commit; GateFallback keeps the handoff visibly intentional.
  useEffect(() => {
    router.replace(destination as never)
  }, [destination, router])

  // Native Preview is a fixture-only QA app. Its default must be discovery so
  // opening it never looks like a fresh production signup; login remains an
  // explicit, protected journey when a tester needs a fixture session.
  return <GateFallback accessibilityLabel={t('common.loading')} testID="gate.auth-index-redirect" />
}
